import moment from 'moment'
import { DATE, TIME } from 'Constants/formats'

function getRandomInt(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min)) + min
  // Максимум не включается, минимум включается
}

let uniqueId = 0

const orderListItem = () => ({
  vendor_code: `vendor_code_${uniqueId++}`,
  product_name: 'Sed consequat leo eget',
  unit_cost: getRandomInt(1, 100),
  check_cost: getRandomInt(1, 100),
  ordered_quantity: getRandomInt(1, 100),
  selected_orders: getRandomInt(1, 100),
  not_available: !!getRandomInt(0, 2),
  replacement: getRandomInt(1, 100)
})

const orderList = () => (
  Array(getRandomInt(1, 10)).fill(null)
    .map(() => orderListItem())
)

export const order = (id) => ({
  id: id || uniqueId++,
  order_number: id || uniqueId,
  order_created_at_date: moment().format(DATE),
  order_created_at_time: moment().format(TIME),
  order_cost: getRandomInt(1, 100),
  order_status: 'order_status',
  order_payment_status: 'order_payment_status',
  order_delivery_status: 'order_delivery_status',
  order_collector_full_name: 'Integer ante arcu',
  address_from: 'Fusce pharetra convallis urna',
  shop_number: getRandomInt(1, 100),
  address_to: 'Phasellus viverra nulla ut',
  comment_from_client: 'Pellentesque ut neque. Vivamus consectetuer hendrerit lacus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Vivamus laoreet.',
  contactless_delivery: !!getRandomInt(0, 2),
  customer_full_name: 'In auctor lobortis',
  courier_service_name: 'Curabitur ligula sapien',
  courier_full_name: 'Phasellus leo dolor',
  courier_phone: '8 800 8000 800',
  order_list: orderList()
})
